class Guide {
    constructor() {
        this.handleBranchSelect();
        this.container = document.getElementById("guide-nav");
        if (!this.container) return;

        this.init = this.init.bind(this);
        this.handleAnchorClick = this.handleAnchorClick.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
        this.handleBackSwipe = this.handleBackSwipe.bind(this);

        this.init();
    }

    init() {
        this.container.querySelectorAll(".pane-nav__links a").forEach((item) => {
            item.addEventListener("click", this.handleAnchorClick);
        });
        this.bindEvents(this.container);

        var startingLevel = this.container.dataset.level;
        for (var i = startingLevel; i > 0; i--) {
            this.setCurrentLevel(i);
        }

        const media = window.matchMedia("(min-width: 992px)");
        const lvl1List = document.querySelector("#guide-level-1 .pane-nav__list");
        if (media.matches && this.container.dataset.preselectedId && !lvl1List) {
            const link = document.querySelector('.pane-nav__links a[data-id="' + this.container.dataset.preselectedId + '"]');
            if (link) {
                const selected = link.parentNode.parentNode.querySelector(".selected");
                if (selected) {
                    selected.classList.remove("selected");
                }
                link.parentNode.classList.add("selected");
                this.load(link, true);
            }
        }
    }

    handleAnchorClick(e) {
        const target = e.currentTarget;
        const selected = target.parentNode.parentNode.querySelector(".selected");

        if (selected) {
            selected.classList.remove("selected");
        }

        target.parentNode.classList.add("selected");

        if (target.dataset.hasContent === "True") {
            return true;
        }
        e.preventDefault();

        this.load(target);
    }

    async load(target, ignoreScroll) {
        history.pushState(null, "", target.href);

        if (parseInt(target.dataset.level) === 0) {
            document.querySelector(".pane-nav__pane--2").innerHTML = "";
        }
        document.querySelector(".pane-nav__pane--3").innerHTML = "";

        const wrapper = document.getElementById(
            `guide-level-${parseInt(target.dataset.level) + 1}`
        );

        wrapper.classList.remove('pane-nav__pane--hidden');
        wrapper.dataset.loading = "true";

        this.setCurrentLevel(parseInt(target.dataset.level) + 1);

        const response = await fetch(
            `./GetNavigationFragment?id=${target.dataset.id}`
        );
        const html = await response.text();

        delete wrapper.dataset.loading;

        wrapper.innerHTML = html;


        this.bindEvents(wrapper);

        if (!ignoreScroll) {
            window.scroll({
                top: this.container.offsetTop - 50,
                behavior: 'smooth'
            });
        }
    }

    setCurrentLevel(level) {
        this.container.dataset.level = level
        const prevWrapper = document.getElementById(
            `guide-level-${(level - 1)}`
        );
        const currentWrapper = document.getElementById(
            `guide-level-${(level)}`
        );
        setTimeout(() => {
            prevWrapper.addEventListener('click', this.handleBackClick);
            currentWrapper.addEventListener('tf.swipe.right', this.handleBackSwipe);
            currentWrapper.addEventListener('tf.swipe.moving', (evt) => {
                currentWrapper.classList.add('pane-nav__pane--moving');
                if (evt.detail.xDiff > 0) {
                    currentWrapper.style = "left:" + evt.detail.xDiff + "px";
                }
            });
            currentWrapper.addEventListener('tf.swipe.ended', (evt) => {
                currentWrapper.classList.remove('pane-nav__pane--moving');
                currentWrapper.style = "";
            });
        }, 500);

    }

    handleBackClick(e) {
        this.doBack(e.currentTarget.dataset.level);
        e.currentTarget.removeEventListener('click', this.handleBackClick);
    }
    handleBackSwipe(e) {
        const newLevel = e.currentTarget.dataset.level - 1;
        this.doBack(newLevel);
        const level0 = document.getElementById(
            `guide-level-${newLevel}`
        );
        if (level0) {
            level0.removeEventListener('click', this.handleBackClick);
        }
    }
    doBack(newLevel) {
        this.container.dataset.level = newLevel;
        const level1 = document.getElementById(
            `guide-level-${(parseInt(newLevel) + 1)}`
        );
        if (level1) {
            level1.classList.add('pane-nav__pane--hidden');
            level1.removeEventListener('click', this.handleBackClick);
            level1.removeEventListener('tf.swipe.right', this.handleBackSwipe);
        }
        const level2 = document.getElementById(
            `guide-level-${(parseInt(newLevel) + 2)}`
        );
        if (level2) {
            level2.classList.add('pane-nav__pane--hidden');
            level2.removeEventListener('click', this.handleBackClick);
            level2.removeEventListener('tf.swipe.right', this.handleBackSwipe);
        }
    }

    bindEvents(container) {
        container.querySelectorAll(".pane-nav__list__anchor").forEach((item) => {
            item.addEventListener("click", this.handleAnchorClick);
        });
    }

    handleBranchSelect() {
        var branchSelect = document.querySelector(".form__select--guide-branch-selector");
        if (branchSelect) {
            branchSelect.addEventListener("change", (e) => {
                var qp = window.location.href.split('?');
                var searchParams = new URLSearchParams(qp.length > 1 ? qp[1] : "");
                searchParams.set('branch', e.target.value);
                window.location.href = qp[0] + "?" + searchParams.toString();
            });

            var qp = window.location.href.split('?');
            var searchParams = new URLSearchParams(qp.length > 1 ? qp[1] : "");
            if (searchParams.has("branch")) {
                setTimeout(() => {
                    document.querySelector("#a-o").scrollIntoView();
                }, 200);
            }
        }

        var agreementSelect = document.querySelector(".form__select--guide-agreement-selector");
        if (agreementSelect) {
            agreementSelect.addEventListener("change", (e) => {
                var qp = window.location.href.split('?');
                var searchParams = new URLSearchParams(qp.length > 1 ? qp[1] : "");
                searchParams.set('agreementArea', e.target.value);
                window.location.href = qp[0] + "?" + searchParams.toString();
            });

            var qp = window.location.href.split('?');
            var searchParams = new URLSearchParams(qp.length > 1 ? qp[1] : "");
            if (searchParams.has("agreementArea")) {
                setTimeout(() => {
                    document.querySelector("#a-o").scrollIntoView();
                }, 200);
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => new Guide());
